import React, { useState } from "react";
import { Dialog, InputAdornment, TextField, Drawer, Checkbox, FormControlLabel } from "@material-ui/core";
import InfiniteScroll from "react-infinite-scroller";
import { P_Props } from "./AgentListing.type";
import { FloatingButton, Loading, Notification, Pulse, CustomButton, CustomStatus } from "../../components";
import { Search as SearchIcon } from "@material-ui/icons";
import { PriorityHigh as PriorityHighIcon, Close as CloseIcon } from "@material-ui/icons";
import { AgentForm } from "..";
import { EditIcon, DeleteIcon, FilterIcon } from "../../icons";
import { AgentOutputModel, AgentStatus } from "../../../models";

const AgentListingPresenter: React.FC<P_Props> = (props) => {
  const [visibleAgentCreateModal, setVisibleAgentCreateModal] = useState<boolean>(false);
  const [visibleDeleteModal, setVisibleDeleteModal] = useState<boolean>(false);
  const [agentDelete, setAgentDelete] = useState<AgentOutputModel | undefined>();
  const [openFilter, setOpenFilter] = useState<boolean>(false);

  const toggleDeleteModal = (agent) => {
    if (agent) {
      setAgentDelete(agent);
    }
    setVisibleDeleteModal(!visibleDeleteModal);
  };

  const openFilterForm = () => {
    setOpenFilter(true);
  };

  const closeFilterForm = () => {
    setOpenFilter(false);
  };

  return (
    <>
      <div className="agent-listing">
        <div className="agent-listing__content">
          <div className="agent-listing__content__header">
            <div className="agent-listing__content__header__title">All Partners</div>
            <div className="agent-listing__content__header__actions">
              <div className="agent-listing__content__header__search">
                <TextField
                  placeholder="Search by name, ID"
                  variant="outlined"
                  className="search-input"
                  inputProps={{ className: "input" }}
                  InputProps={{
                    // style: { fontSize: "1.4rem" },
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon className="icon" />
                      </InputAdornment>
                    ),
                  }}
                  onChange={(e) => {
                    props.onSearch(e.target.value);
                  }}
                />
              </div>
              <div className="agent-listing__content__header__filter" onClick={openFilterForm}>
                <FilterIcon size={[18, 18]} viewBox={[18, 18]} color={"#272B2F"} />
                <h4 className="agent-listing__content__header__filter__title">Filter</h4>
              </div>
            </div>
          </div>
          <div className="agent-listing__content__list">
            <div className="agent-listing__content__list__header">
              <div className="text agent-listing__content__list__index">Order no.</div>
              <div className="text agent-listing__content__list__code">Partner ID</div>
              <div className="text agent-listing__content__list__name">Company Name</div>
              <div className="text agent-listing__content__list__country">Country</div>
              <div className="text agent-listing__content__list__city">City</div>
              <div className="text agent-listing__content__list__status">Status</div>
              <div className="text agent-listing__content__list__actions"></div>
            </div>
            <InfiniteScroll
              useWindow={false}
              pageStart={1}
              initialLoad={false}
              hasMore={!props.fetchedAgent.loading && props.fetchedAgent.totalPages > props.fetchedAgent.page}
              loadMore={() => {
                props.onLoadMore();
              }}
            >
              {!Boolean(props.fetchedAgent.data.length) && props.fetchedAgent.loading && <Loading />}
              {props.fetchedAgent.data.map((agent, index) => {
                return (
                  <div
                    key={agent.id}
                    className="agent-listing__content__list__item"
                  >
                    <div className="agent-text agent-listing__content__list__index">{index + 1}</div>
                    <div className="agent-text agent-listing__content__list__code">{agent.code}</div>
                    <div className="agent-text agent-listing__content__list__name">{agent.companyName}</div>
                    <div className="agent-text agent-listing__content__list__country">{agent.country}</div>
                    <div className="agent-text agent-listing__content__list__city">{agent.city}</div>
                    <div className="agent-text agent-listing__content__list__status">
                      <CustomStatus
                        color={
                          agent.status === AgentStatus.ACTIVE
                            ? "#08C4E3"
                            : agent.status === AgentStatus.INACTIVE
                              ? "#BDC6D7"
                              : ""
                        }
                        title={agent.status === AgentStatus.ACTIVE
                          ? "Active"
                          : agent.status === AgentStatus.INACTIVE
                            ? "In Active"
                            : ""
                        }
                        style={{ textTransform: "capitalize" }}
                      />
                    </div>
                    <div className="agent-text agent-listing__content__list__actions">
                      <CustomButton onClick={(e) => {
                        e.stopPropagation();
                        props.openEditAgentFormModal(agent, agent.id);
                      }}
                        color={"transparent"}
                        item={
                          <span>
                            <EditIcon size={[20, 20]} viewBox={[20, 20]} color={"#272B2F"} />
                          </span>
                        } />
                      <CustomButton
                        onClick={(e) => {
                          e.stopPropagation();
                          e.preventDefault();
                          toggleDeleteModal(agent);
                        }}
                        color={"transparent"}
                        item={
                          <span>
                            <DeleteIcon size={[20, 20]} viewBox={[20, 20]} color={"#272B2F"} />
                          </span>
                        }
                      />
                    </div>
                  </div>
                );
              })}
              {Boolean(props.fetchedAgent.data.length) && props.fetchedAgent.loading && <Loading />}
            </InfiniteScroll>
          </div>
        </div>
      </div>

      <FloatingButton
        visible={false}
        onClickPrimary={() => setVisibleAgentCreateModal(true)}
        btns={[
          // {
          //   color: "primary",
          //   title: "Khách hàng",
          //   icon: <ProductIcon size={[24, 24]} color="white" />,
          //   onClick: (e) => {
          //     setVisibleCustomerCreateModal(true);
          //   },
          // },
        ]}
      />

      {/* Form Create Agent */}
      <Dialog fullScreen open={visibleAgentCreateModal}>
        <AgentForm
          agentId={props.visibleAgentId}
          onCancel={() => {
            setVisibleAgentCreateModal(false);
          }}
          onComplete_Create={() => {
            setVisibleAgentCreateModal(false);
            props.onCompleteCreateAgent();
          }}
        />
      </Dialog>

      {/* Form Edit Agent */}
      <Dialog fullScreen open={Boolean(props.visibleAgentForm)}>
        <AgentForm
          initial={props.visibleAgentForm || undefined}
          agentId={props.visibleAgentId}
          onCancel={() => props.closeEditAgentFormModal()}
          onComplete_Update={() => {
            props.closeEditAgentFormModal()
            props.onCompleteUpdateAgent()
            // props.onReloadCustomerDetail();
          }}
        // onComplete_Delete={() => {
        //   props.onClose(props.fetchedCustomer.data!);
        // }}
        />
      </Dialog>

      <Notification
        visible={visibleDeleteModal}
        title="Delete partner"
        subTitle={`Are you sure you want to delete partner “${agentDelete?.companyName}“?`}
        icon={
          <Pulse color={"red"}>
            <div className="notification-icon-box red">
              <PriorityHighIcon style={{ fontSize: "5rem", color: "#fff" }} />
            </div>
          </Pulse>
        }
        actions={
          <>
            <button
              className="agent-form__delete-modal__actions__cancel"
              onClick={() => {
                toggleDeleteModal(agentDelete);
              }}
            >
              Cancel
            </button>
            <button
              className="agent-form__delete-modal__actions__confirm"
              onClick={() => {
                toggleDeleteModal(agentDelete);
                if (agentDelete?.id) {
                  props.onDeleteAgent(agentDelete.id);
                }
              }}
            >
              Confirm
            </button>
          </>
        }
      />
      
      <Drawer anchor="right" open={openFilter} onClose={closeFilterForm}>
        <div className="drawer">
          <div className="drawer-header">
            <div className="drawer-header--title">Filter</div>
            <div className="drawer-header--close">
              <button
                onClick={closeFilterForm}
                className="simple-modal-header__close"
                style={{ marginRight: "2.6rem" }}
              >
                <CloseIcon style={{ fontSize: "2.2rem" }} />
              </button>
            </div>
          </div>
          <div className="drawer-body--field">
            <div className="drawer-body--field__title">Status</div>
            <FormControlLabel
              control={
                <>
                  <Checkbox
                    checked={props.statusFilter.publish}
                    onChange={e => props.handleChangeCheckBox(e)}
                    name="publish"
                  />
                  <div className="custom-status__icon" style={{ backgroundColor: "#08c4e3" }} />
                </>
              }
              label="Active"
            />
            <FormControlLabel
              control={
                <>
                  <Checkbox
                    checked={props.statusFilter.unpublish}
                    onChange={e => props.handleChangeCheckBox(e)}
                    name="unpublish"
                  />
                  <div className="custom-status__icon" style={{ backgroundColor: "#BDC6D7" }} />
                </>
              }
              label="In Active"
            />
          </div>
          <div className="drawer-footer">
            <button
              type="reset"
              className="btn cancel"
              onClick={props.clearFilter}
            >
              Clear filter
            </button>
            <button
              className="btn save"
              onClick={() => {
                closeFilterForm();
                props.onApplyStatusFilter();
              }}
            >
              Apply
            </button>
          </div>
        </div>
      </Drawer>
    </>
  );
};

export default AgentListingPresenter;
